export default {
  GET_AUTOMATION_TRIGGERS: 'getAutomationTriggers',
  GET_ALL_AUTOMATIONS: 'getAllAutomations',
  SAVE_AUTOMATION: 'saveAutomation',
  UPDATE_AUTOMATION: 'updateAutomation',
  DELETE_AUTOMATION: 'deleteAutomation',
  GET_AUTOMATIONS_BY_NODE: 'getAutomationsByNode',
  GET_AUTOMATION: 'getAutomation',
  ADD_AUTOMATION_NODE_RELATIONSHIP: 'addAutomationNodeRelationship',
  REMOVE_AUTOMATION_NODE_RELATIONSHIP: 'removeAutomationNodeRelationship'
}
